export default __webpack_public_path__ + "static/media/usdt.ad15d58d.png";